/**
 * 将时间戳转换为指定格式的时间字符串
 * @param {number|string} timestamp - 时间戳（秒或毫秒）
 * @returns {string} 格式化后的时间字符串 (YYYY-MM-DD HH:mm:ss)
 */
export function formatTimestamp(timestamp , format = 'YYYY-MM-DD') {
  // 如果传入的是秒级时间戳，转换为毫秒


  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  if (format === 'YYYY-MM-DD'){
    return `${year}-${month}-${day}`;
  }else {
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
export function formatTimes (timestamp  ) {
  // 如果传入的是秒级时间戳，转换为毫秒


  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  // const hours = String(date.getHours()).padStart(2, '0');
  // const minutes = String(date.getMinutes()).padStart(2, '0');
  // const seconds = String(date.getSeconds()).padStart(2, '0');
   return {
     day,
     date: `${year}年${month}月`,
   }
}
